import { useEffect, useRef, useState } from 'react';
import './Form.css';
function submit(user,message,handleData){
  //console.log("ciao")
  const data = JSON.parse(localStorage.getItem("data"))
  var comment ={
    "id":data.nextID,
    "content": message,
    "createdAt": "Today",
    "score": 0,
    "user": {
      "image": { 
        "png": user.image.png,
        "webp": user.image.webp
      },
      "username": user.username
    },
    "replies": []
  }
  data.nextID += 1
  data.comments.push(comment)
  localStorage.setItem("data",JSON.stringify(data))
 
  handleData()


}
function replySubmit(user,message,name,id,handleReply,handleData){
  const data = JSON.parse(localStorage.getItem("data"))
  var comment ={
    "id": data.nextID,
    "content":message,
    "createdAt": "today",
    "score": 0,
    "replyingTo": name,
    "user": {
      "image": { 
        "png": user.image.png,
        "webp": user.image.webp
      },
      "username": user.username
    }
  }
  data.nextID += 1
  //console.log(id)
  data.comments.forEach(element => {
    if(element.id===id){
      //console.log('UGUALEEEEE')
      element.replies.push(comment)}
  });
  localStorage.setItem("data",JSON.stringify(data))
  handleReply()
  handleData()
}



const Form = ({user,reply,name,id,handleReply,handleData})=>{
  
  const [message,setMessage] = useState(()=>"")
  const focus = useRef(null)
  
  const handleMessageChange = event => {
    setMessage(event.target.value);
   // console.log(event.target.value);
  };
  
  useEffect(()=>{
    focus.current.focus()
  },[])

  return (
    <div className="formAnswer">
      <div className='picture'>
        <img src={user.image.png} alt="profile"/>
      </div>
      <textarea  ref = {focus} onChange={handleMessageChange}></textarea>
      <div className='button' onClick={reply?()=>replySubmit(user,message,name,id,handleReply,handleData):()=>submit(user,message,handleData)}>
        {reply? "REPLY":"SEND"}
      </div>
    </div>
    )
}
export default Form;